var _defs, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.15 20.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .events-icon-item-1 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "local_activity_FILL0_wght400_GRAD0_opsz48",
    "data-name": "local activity FILL0 wght400 GRAD0 opsz48",
    className: "cls-2",
    d: "M1.88,20.13c-.5,0-.98-.2-1.32-.57C.2,19.22,0,18.74,0,18.24v-4.81c.77-.16,1.45-.59,1.93-1.21.5-.61.77-1.37.77-2.15,0-.79-.27-1.56-.77-2.17C1.46,7.27.77,6.84,0,6.7V1.88c0-.5.2-.98.57-1.32C.91.2,1.39,0,1.88,0h21.39c1.03.03,1.86.85,1.88,1.88v4.81c-.77.14-1.45.57-1.92,1.19-.49.62-.76,1.38-.75,2.17,0,.78.26,1.54.75,2.15.47.62,1.15,1.05,1.92,1.21v4.81c-.03,1.03-.85,1.86-1.88,1.88H1.88ZM1.88,18.24h21.39v-3.43c-.77-.54-1.42-1.23-1.9-2.03-1.03-1.67-1.03-3.77,0-5.44.49-.8,1.14-1.49,1.9-2.03V1.88H1.88v3.43c.77.54,1.42,1.23,1.92,2.03,1.05,1.66,1.05,3.78,0,5.44-.5.8-1.15,1.49-1.92,2.03v3.43Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_",
    "data-name": " ",
    className: "events-icon-item-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "events-icon-item-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.68,13.89c0-.86.69-1.51,1.67-1.51s1.66.64,1.66,1.51-.67,1.54-1.66,1.54-1.67-.69-1.67-1.54ZM10.69,5.04h3.31l-.56,6.52h-2.21l-.54-6.52Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack13);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-13.e64220da8cfc28f40cf0feae30ca98d5.svg";
export { ForwardRef as ReactComponent };